export default class Product {
    constructor(names, shortDescriptions, longDescriptions, packageDimensions, tags, datasheets, shippings, categories, prices, tax, modelFile, mtlFile, svgFile, files, inStock,eCommerce,highlighted,model,price,paletteId,sku,videoUrl,weight,length,width,height,otherDimensions,motors) {
        
        // {} instead of array to support stringify        
        this.names = names;
        this.shortDescriptions = shortDescriptions;
        this.longDescriptions = longDescriptions;
        this.packageDimensions = packageDimensions;
        this.tags = tags;
        this.datasheets = datasheets;
        
        this.shippings = shippings;
        this.categories = categories;
        this.prices = prices;
        this.tax = tax;
        
        this.modelFile = modelFile;
        this.mtlFile = mtlFile;
        this.svgFile = svgFile;
        this.files = files;
        this.activeBrandsProFiles = [];

        this.inStock = inStock;
        this.eCommerce = eCommerce;
        this.highlighted = highlighted;
        this.showOnActiveBrandsPro = false;
        this.model = model;
        this.price = price;
        this.paletteId = paletteId;
        this.sku = sku;
        this.videoUrl = videoUrl;
        this.weight = weight;
        this.length = length;
        this.width = width;
        this.height = height;
        this.otherDimensions = otherDimensions;
        this.motors = motors;
    }

    isValid() {
        var result = true;

        for (const [key, value] of Object.entries(this.names)) { if(!value) { result = false; break; }; }
        for (const [key, value] of Object.entries(this.shortDescriptions)) { if(!value) { result = false; break; }; }
        for (const [key, value] of Object.entries(this.longDescriptions)) { if(!value) { result = false; break; }; }
        for (const [key, value] of Object.entries(this.packageDimensions)) { if(!value) { result = false; break; }; }
        for (const [key, value] of Object.entries(this.tags)) { if(!value || !value.length) { result = false; break; }; }

        if(result) result = this.categories && this.categories.length && this.sku && this.weight && this.length && this.width && this.height;

        // validation if ecommerce == true
        if(result && this.eCommerce)
        {
            if(this.shippings[0]) result = this.price && this.tax && this.shippings[0].days && this.shippings[0].price;
            if(this.shippings[0] && this.shippings[1]) result = this.price && this.tax && this.shippings[0].days && this.shippings[0].price && this.shippings[1].days && this.shippings[1].price;
        }
        // validation if ecommerce and model == true
        if(result && this.eCommerce && this.model) 
        {
            result = this.modelFile && this.mtlFile && this.svgFile && this.paletteId;
        }
        
        // videoUrl, files(pdf), motors, otherDimensions, model, ecommerce, stock, highlighted and prices(to define quantity-based discounts) are optional

        return result;
    }
}